/* GEN — Page fabricant : recherche par moto (marques → modèles, suggestions) et par référence (recherche Shopify sur le SKU), tri. */
(function () {
  document.querySelectorAll('[data-gen-fab]').forEach(function (root) {
    var $ = function (s, r) { return (r || root).querySelector(s); };
    var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
    var reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var q = $('.e-champ input'), sug = $('.e-sugg'), pfx = $('.pfx'), bm = $('[data-mode="moto"]'), br = $('[data-mode="ref"]');
    var marques = $('.e-marques'), aide = $('.e-aide'), zoneSec = $('.e-sombre'), titre = $('[data-e-titre]'), sous = $('[data-e-sous]');
    var cartes = $$('.a-motos .mc'), plus = $('[data-e-plus]'), res = $('.e-res');
    var vendeur = (root.dataset.vendor || '').toUpperCase();
    var mode = null, marque = null, liste = [], act = 0, minuteur = null;
    var estMob = function () { return root.getBoundingClientRect().width < 700; };
    var T = {}; try { T = JSON.parse(root.dataset.i18n || '{}'); } catch (e) {}
    var tx = function (k, d, n, m) { return String(T[k] || d).replace('[n]', n).replace('[m]', m); };
    var refPfx = (root.dataset.refPfx || 'PRN').toUpperCase(), refN = +root.dataset.refN || 6, refEx = root.dataset.refEx || '';
    var echap = function (t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var reNorm = new RegExp((vendeur ? echap(vendeur.split(' ')[0]) + '|' : '') + echap(refPfx) + '|[\\s\\-–_.\\/]', 'g');
    var norm = function (t) { return (t || '').toUpperCase().replace(reNorm, ''); };
    var nomMq = function (m) { return m === 'BMW' || m === 'KTM' ? m : m.charAt(0) + m.slice(1).toLowerCase(); };
    var MOTOS = cartes.map(function (c) { return { el: c, mq: c.dataset.mq, nom: c.dataset.nom, n: +c.dataset.n, img: c.dataset.img, url: c.getAttribute('href') }; });
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var placeholder = function () { q.placeholder = mode === 'ref' ? refEx : (estMob() ? tx('ph_mob', 'Votre moto : Panigale, MT-09…') : tx('ph_pc', 'Votre moto : Panigale, MT-09, Street Triple…')); };

    /* biseau rouge qui glisse sous le bouton actif */
    function placer() {
      $$('.e-mode,.e-marques').forEach(function (g) {
        var ind = $('.e-ind', g), a = $('button[aria-pressed="true"]', g);
        if (!ind) return;
        if (!a) { ind.hidden = true; return; }
        ind.hidden = false;
        g.style.setProperty('--x', a.offsetLeft + 'px'); g.style.setProperty('--y', a.offsetTop + 'px');
        g.style.setProperty('--w', a.offsetWidth + 'px'); g.style.setProperty('--h', a.offsetHeight + 'px');
      });
    }

    function montrerMotos(liste_, t, st) {
      cartes.forEach(function (c) { c.hidden = true; });
      res.hidden = true;
      liste_.forEach(function (m, i) { m.el.hidden = false; m.el.classList.toggle('m-plus', i >= 6); });
      $('.a-motos').classList.remove('tout');
      var surplus = liste_.length - 6;
      plus.hidden = !(surplus > 0 && estMob());
      if (surplus > 0) plus.textContent = tx('plus_autres', 'Voir les [n] autres modèles', surplus);
      titre.textContent = t; sous.textContent = st;
      zoneSec.hidden = !liste_.length && !st;
    }
    if (plus) plus.addEventListener('click', function () { $('.a-motos').classList.add('tout'); plus.hidden = true; });

    function choisirMarque(m) {
      marque = m;
      $$('button', marques).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.m === m); });
      requestAnimationFrame(placer);
      var ms = MOTOS.filter(function (x) { return x.mq === m; }).sort(function (a, b) { return b.n - a.n; });
      var conteneur = $('.a-motos'); ms.forEach(function (x) { conteneur.appendChild(x.el); });
      var total = ms.reduce(function (a, x) { return a + x.n; }, 0);
      montrerMotos(ms, tx('votre', 'Votre [m]', 0, nomMq(m)), ms.length ? ms.length + ' ' + (ms.length > 1 ? tx('modele_n', 'modèles') : tx('modele_1', 'modèle')) + ' · ' + total + ' ' + tx('acc_n', 'accessoires') : tx('universels', 'Accessoires universels : ils sont dans la liste ci-dessous.'));
    }

    function setMode(m) {
      if (m === 'moto') {
        var ouvrir = !(mode === 'moto' && !marques.hidden);
        mode = 'moto';
        marques.hidden = !ouvrir; aide.hidden = true;
        bm.setAttribute('aria-pressed', ouvrir); bm.setAttribute('aria-expanded', ouvrir); br.setAttribute('aria-pressed', 'false');
        marque = null; $$('button', marques).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        zoneSec.hidden = true;
      } else {
        mode = 'ref';
        marques.hidden = true; aide.hidden = false; zoneSec.hidden = true;
        bm.setAttribute('aria-pressed', 'false'); bm.setAttribute('aria-expanded', 'false'); br.setAttribute('aria-pressed', 'true');
      }
      pfx.hidden = mode !== 'ref'; q.value = ''; placeholder(); fermerSugg();
      requestAnimationFrame(placer);
      if (mode === 'ref') q.focus();
    }
    /* marque sans recherche par moto (SP CONNECT) : la recherche s'ouvre directement sur la référence, sans prendre le focus */
    if (root.hasAttribute('data-sans-moto')) { mode = 'ref'; if (pfx) pfx.hidden = false; placeholder(); requestAnimationFrame(placer); }
    bm.addEventListener('click', function () { setMode('moto'); });
    br.addEventListener('click', function () { setMode('ref'); });
    if (marques) marques.addEventListener('click', function (e) { var b = e.target.closest('button[data-m]'); if (b) choisirMarque(b.dataset.m); });

    /* ----- suggestions ----- */
    function fermerSugg() { sug.hidden = true; q.setAttribute('aria-expanded', 'false'); }
    function trouveMotos(t) {
      var n = norm(t); if (!n) return [];
      var cle = function (m) { return (m.mq + m.nom).replace(/[\s\-\/]/g, ''); }, cle2 = function (m) { return m.nom.replace(/[\s\-\/]/g, ''); };
      return MOTOS.map(function (m) { return { m: m, r: cle2(m) === n || cle(m) === n ? 0 : cle2(m).indexOf(n) === 0 || cle(m).indexOf(n) === 0 ? 1 : cle(m).indexOf(n) >= 0 ? 2 : 9 }; })
        .filter(function (x) { return x.r < 9; }).sort(function (a, b) { return a.r - b.r || b.m.n - a.m.n; }).slice(0, 7).map(function (x) { return x.m; });
    }
    function peindreSugg(html) { sug.innerHTML = html; sug.hidden = false; q.setAttribute('aria-expanded', 'true'); act = 0; marquer(); }
    function marquer() { $$('a[role="option"]', sug).forEach(function (a, k) { a.setAttribute('aria-selected', k === act); }); }
    var euro = function (p) { return (+p).toFixed(2).replace('.', ',') + '€'; };

    function suggMotos() {
      liste = trouveMotos(q.value);
      if (!q.value.trim()) { fermerSugg(); return; }
      peindreSugg(liste.length ? liste.map(function (m, i) {
        return '<a href="' + esc(m.url) + '" role="option" data-i="' + i + '">' + (m.img ? '<img src="' + esc(m.img) + '" alt="" style="object-fit:cover">' : '<span style="width:48px;height:48px;border-radius:8px;background:#26272c;display:grid;place-items:center;font:italic 700 10px var(--ui);color:#fff">' + esc(m.mq) + '</span>') +
          '<span class="t"><b>' + esc(nomMq(m.mq) + ' ' + m.nom) + '</b><small>' + m.n + ' ' + esc(tx('acc_n', 'accessoires')) + '</small></span><span class="px" style="color:#ff4a4f">›</span></a>';
      }).join('') : '<div class="vide">' + esc(tx('aucun_modele', 'Aucun modèle ne correspond. Essayez « Panigale », « MT-09 » ou « S1000RR ».')) + '</div>');
    }

    /* référence : recherche Shopify sur le SKU (PRN…), limitée au fabricant de la page */
    function variantesRequete(t) {
      var n = norm(t), out = [];
      /* forme exacte du SKU (ex. MG-####-######) : les chiffres saisis sont remis dans cette forme */
      var motif = root.dataset.refMotif || '';
      if (motif && /^\d+$/.test(n)) {
        var k = 0, nb = (motif.match(/#/g) || []).length;
        if (n.length === nb) out.push(motif.replace(/#/g, function () { return n.charAt(k++); }));
        out.push(n);
        return out;
      }
      if (/^\d+$/.test(n)) { var p = n.length < refN ? (Array(refN + 1).join('0') + n).slice(-refN) : n; out.push(refPfx + p); out.push(p); }
      else if (n) out.push(t.trim());
      return out;
    }
    function rechercherRef() {
      var t = q.value; if (!t.trim()) { fermerSugg(); return; }
      var reqs = variantesRequete(t).map(function (x) {
        var u = (window.routes && window.routes.predictive_search_url || '/search/suggest') + '.json?q=' + encodeURIComponent(x) +
          '&resources[type]=product&resources[limit]=10&resources[options][fields]=variants.sku,title,vendor&resources[options][unavailable_products]=last';
        return fetch(u).then(function (r) { return r.json(); }).then(function (j) { return (j.resources && j.resources.results && j.resources.results.products) || []; }).catch(function () { return []; });
      });
      Promise.all(reqs).then(function (lots) {
        if (t !== q.value) return;
        var vus = {}; liste = [];
        lots.forEach(function (l) { l.forEach(function (p) { if (vus[p.id] || (vendeur && (p.vendor || '').toUpperCase() !== vendeur)) return; vus[p.id] = 1; liste.push(p); }); });
        liste = liste.slice(0, 8);
        peindreSugg(liste.length ? liste.map(function (p, i) {
          var parts = p.title.split('|');
          return '<a href="' + esc(p.url) + '" role="option" data-i="' + i + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
            '<span class="t"><b>' + esc(parts[0].trim()) + '</b><small>' + esc((parts[1] || '').trim()) + '</small></span><span class="px">' + euro(p.price) + '</span></a>';
        }).join('') : '<div class="vide">' + esc(tx('aucune_ref', 'Aucune pièce ne porte cette référence chez nous. Vérifiez le numéro ou contactez-nous : nous la commandons pour vous.')) + '</div>');
      });
    }

    q.addEventListener('focus', function () { if (!mode) { mode = 'moto'; } placeholder(); });
    q.addEventListener('input', function () {
      if (!mode) mode = 'moto';
      clearTimeout(minuteur);
      if (mode === 'ref') minuteur = setTimeout(rechercherRef, 220); else suggMotos();
    });
    q.addEventListener('keydown', function (e) {
      if (sug.hidden) return;
      var opts = $$('a[role="option"]', sug);
      if (e.key === 'ArrowDown') { act = Math.min(act + 1, opts.length - 1); marquer(); e.preventDefault(); }
      if (e.key === 'ArrowUp') { act = Math.max(act - 1, 0); marquer(); e.preventDefault(); }
      if (e.key === 'Escape') fermerSugg();
      if (e.key === 'Enter') { e.preventDefault(); if (opts[act]) window.location.href = opts[act].getAttribute('href'); }
    });
    q.addEventListener('blur', function () { setTimeout(fermerSugg, 180); });

    /* liens des modèles du bas de page : « + N autres » */
    var pl = $('[data-plus-l]'), liens = $('[data-liens]');
    if (pl && liens) {
      var total = pl.textContent.trim();
      var ouvrirLiens = function (o) {
        liens.classList.toggle('tout', o); pl.setAttribute('aria-expanded', o); if (o) liens.style.maxHeight = ''; else caler();
        $('[data-plus-t]', pl).textContent = o ? tx('reduire', 'Réduire la liste') : total;
      };
      /* le pli tombe entre deux rangées de liens (jamais un lien coupé à moitié) : 3 rangées visibles */
      var caler = function () {
        if (liens.classList.contains('tout')) return;
        liens.style.maxHeight = '';
        var hauts = [];
        $$('a', liens).forEach(function (a) { var t = a.offsetTop; if (hauts.indexOf(t) < 0) hauts.push(t); });
        hauts.sort(function (x, y) { return x - y; });
        if (hauts.length > 3) liens.style.maxHeight = (hauts[3] - hauts[0] - 2) + 'px';
      };
      caler();
      window.addEventListener('resize', caler);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(caler);
      /* liste déjà courte : pas de pli */
      if (liens.scrollHeight <= liens.clientHeight + 4) { liens.classList.add('tout', 'court'); pl.hidden = true; }
      pl.addEventListener('click', function () { ouvrirLiens(pl.getAttribute('aria-expanded') !== 'true'); });
      /* un lien atteint au clavier ouvre la liste, pour ne jamais être caché sous le fondu */
      liens.addEventListener('focusin', function () { if (!liens.classList.contains('tout')) ouvrirLiens(true); });
    }

    /* tri */
    var tri = $('[data-tri]');
    if (tri) tri.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', tri.value); u.searchParams.delete('page'); location.href = u.toString(); });

    placeholder();
    window.addEventListener('resize', function () { placeholder(); placer(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(placer);
    if (reduit) root.classList.add('sans-anim');
  });
})();
